import { ReduxUtils } from '../dependencies';

export const roundingMode = ReduxUtils.strictObjectAccess({
    NONE: 0,
    FROM_BASE: 1,
    FROM_VAT: 2,
});
